import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { OPTIONS } from "@/lib/onboardingOptions";
import ChipGrid from "./ChipGrid";

const transition = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };

export default function Step1IdeaVision({ draft, setDraft, next }) {
  const set = (field) => (v) => setDraft((d) => ({ ...d, [field]: v }));
  const canContinue =
    draft.building && draft.target_customer && draft.core_problem && draft.revenue_model;

  return (
    <motion.div
      data-testid="onboarding-step-1"
      key="step-1"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={transition}
      className="text-white"
    >
      <h2 className="text-[28px] font-extrabold leading-[1.1] tracking-tight md:text-[32px]">
        What are you building?
      </h2>
      <p className="mt-2 text-[13px] text-white/55">
        4 quick questions — your boardroom tailors every debate to your idea.
      </p>

      <div className="mt-6 space-y-6">
        <Group label="What are you building?">
          <ChipGrid
            testIdPrefix="q-building"
            options={OPTIONS.building}
            value={draft.building}
            onChange={set("building")}
            columns={2}
          />
        </Group>

        <Group label="Who is your target customer?">
          <ChipGrid
            testIdPrefix="q-target-customer"
            options={OPTIONS.target_customer}
            value={draft.target_customer}
            onChange={set("target_customer")}
            columns={2}
          />
        </Group>

        <Group label="What core problem does your startup solve?">
          <ChipGrid
            testIdPrefix="q-core-problem"
            options={OPTIONS.core_problem}
            value={draft.core_problem}
            onChange={set("core_problem")}
            columns={3}
          />
        </Group>

        <Group label="What revenue model are you planning?">
          <ChipGrid
            testIdPrefix="q-revenue-model"
            options={OPTIONS.revenue_model}
            value={draft.revenue_model}
            onChange={set("revenue_model")}
            columns={2}
          />
        </Group>
      </div>

      <footer className="mt-8 flex items-center justify-end">
        <button
          type="button"
          data-testid="onboarding-step-continue"
          disabled={!canContinue}
          onClick={next}
          className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-[13px] font-bold text-black shadow-[0_10px_30px_-10px_rgba(255,255,255,0.5)] transition-opacity disabled:opacity-40"
        >
          Continue
          <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.6} />
        </button>
      </footer>
    </motion.div>
  );
}

function Group({ label, children }) {
  return (
    <div>
      <div className="eyebrow mb-2 text-white/55">{label}</div>
      {children}
    </div>
  );
}
